import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UIRouterModule} from '@uirouter/angular';
import {TranslateModule} from '@ngx-translate/core';
import {CrudModule} from '@ngx-ivengi/crud';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {HttpClientModule} from '@angular/common/http';
import {CleanzoneModule} from '@ngx-ivengi/cleanzone';
import {BsDropdownModule, PopoverModule} from 'ngx-bootstrap';
import {ConfirmationModule} from '../confirmation/confirmation.module';
import {BoolToTextPipe} from './bool-to-text.pipe';
import {DefaultPipe} from './default.pipe';
import {PlaceholderComponent} from './placeholder.component';
import {SharedService} from './shared.service';

@NgModule({
  declarations: [
    DefaultPipe,
    BoolToTextPipe,
    PlaceholderComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    TranslateModule,
    CrudModule,
    NgxDatatableModule,
    HttpClientModule,
    ConfirmationModule,
    BsDropdownModule,
    DefaultPipe,
    BoolToTextPipe,
    PopoverModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    TranslateModule,
    CrudModule,
    NgxDatatableModule,
    HttpClientModule,
    CleanzoneModule,
    ConfirmationModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
  ],
  providers: [
    SharedService
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/shared/shared.module.ts